import { BookmarkResponse } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { useAppSelector } from 'store/store';

type UseBookmarkResponse = {
    bookmarks: BookmarkResponse[];
    getBookmarkByReferenceId: (referenceId: string) => BookmarkResponse | undefined;
};

export const useBookmark = (): UseBookmarkResponse => {
    const bookmarks = useAppSelector(state => state.bookmark.items) || [];
    const getBookmarkByReferenceId = (referenceId: Nullable<string>) => {
        const bookmark = bookmarks.find(b => !!referenceId && referenceId.toLocaleLowerCase() === b.referenceId?.toLocaleLowerCase());

        return bookmark;
    };
    return {
        bookmarks,
        getBookmarkByReferenceId,
    };
};